import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

// Import only the Bootstrap components we need
import { Tooltip, Popover } from 'bootstrap';

// Initialize popovers
document.querySelectorAll('[data-bs-toggle="popover"]')
    .forEach(popover => {
        new Popover(popover)
    })

// Initialize tooltips
document.querySelectorAll('[data-bs-toggle="tooltip"]')
    .forEach(tooltip => {
        new Tooltip(tooltip)
    })

import axios from 'axios';
window.axios = axios;

import $ from 'jquery';
window.$ = window.jQuery = $;

import select2 from 'select2';
select2();

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
